'use es6';

import I18n from 'I18n';
import * as SimpleDate from 'UIComponents/core/SimpleDate';
export const getStateFromIsoDate = iso => {
  if (!iso) {
    return {
      date: null,
      time: null,
      timezone: ''
    };
  }
  const m = I18n.moment(iso);
  const startOfDay = m.clone().startOf('day');
  return {
    date: SimpleDate.fromMoment(m),
    // SimpleDate representing day
    time: m.diff(startOfDay, 'minutes'),
    // Minutes since midnight
    timezone: m.format('Z')
  };
};
export const getIsoDateFromState = ({
  date,
  time,
  timezone
}) => {
  const m = I18n.moment({
    year: date.year,
    month: date.month,
    day: date.date,
    hour: time / 60,
    minute: time % 60,
    second: 0
  }).utcOffset(timezone, true);
  return m.toISOString();
};
export const getStateFromDateString = dateString => {
  const m = I18n.moment(dateString, 'YYYY-MM-DD');
  return {
    date: SimpleDate.fromMoment(m)
  };
};
export const getDateStringFromState = ({
  date
}) => {
  return SimpleDate.toFormattedString(date, 'YYYY-MM-DD');
};